<script>
  import {getHomepage} from "../api/homepage";

  import {onMount} from "svelte";

  const socialUrls = {
    "facebook":  "https://www.facebook.com/%s",
    "instagram": "https://www.instagram.com/%s",
    "twitter":   "https://www.twitter.com/%s"
  };

  let data = null;

  onMount(async() => {
    try {
      data = await getHomepage();
    } catch(error) {
      console.error(error);
    }
  });
</script>

<div class="container-fluid block mt-5 mt-md-0">
    <div class="row box">
        <div class="col-12 col-md-3 offset-md-2">
            <a href="https://umarlestatuty.pl">
                <img
                        class="img-fluid"
                        src="images/logo.png"
                        alt="Stowarzyszenie Umarłych Statutów"
                />
            </a>
        </div>

        {#if data}
            <div class="col-12 col-md-4 col-xxl-3 offset-md-1 my-5 my-md-0 description-container">
                <p class="description text-center text-md-left">
                    Stowarzyszenie Umarłych Statutów to największa w Polsce organizacja
                    zajmującą się obroną praw uczniów. W przypadku pytań związanych z
                    publikacją lub naszą działalnością, zapraszamy do kontaktu:
                    <span>kontakt</span><span>@</span><span>umarlestatuty</span><span>.</span><span>pl</span>.
                </p>
            </div>
        {/if}
    </div>
</div>

<div class="container mb-5">
    <div class="row">
        {#if data}
            {#each data.socials as social, index}
                <div class="col-4 col-md-2 social {index === 0 ? 'offset-md-3' : ''}">
                    <a
                            target="_blank"
                            href="{socialUrls[social.network].replace('%s', social.username)}"
                    ><i class="ci-{social.network}"></i>
                    </a>
                </div>
            {/each}
        {/if}
    </div>
</div>

<style>
    .box {
        margin: 0 !important;
    }

    .block {
        display: flex;
        align-items: center;
        height: 50vh;
        padding: 0 !important;
        overflow-y: visible;
    }

    .description-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .description {
        font-family: "Work Sans";
        font-size: 14px;
        line-height: 16px;
        color: #425466;
        margin-bottom: 0;
    }

    .social {
        font-size: 82px;
        display: flex;
        justify-content: center;
    }

    .social a {
        text-decoration: none;
        color: #425466;
        transition: opacity 0.15s ease-in-out;
    }

    .social a:hover {
        opacity: 0.8;
    }
</style>
